// /admin/danger — WHO MAY RUN EACH ACTION (CRUD-CONFIRM-STANDARD D10,
// 2026-10-30). The page opens to every `admin.danger.access` holder, but the
// server allows two of its three actions to far fewer callers. Read from the
// server's own rules (server origin/main ede72eba0):
//
//   • PURGE — POST /chat/messages/purge answers 403 `admin_role_required`
//     unless `auth.isSuperadmin` (workers/workspace-project/src/surfaces/
//     chat.js:416-418), and that is the caller's Mongo `User.globalRole ===
//     'admin'` (workers/workspace-project/src/auth.js:404-407). Its two token
//     legs (`symbols_role`, `symbols_roster_role`) were minted by the Supabase
//     auth plane, gone since 2026-07-27; nothing issues them now. A
//     `globalRole: 'owner'` does NOT pass it.
//   • DEACTIVATE — every write is PATCH /users/:userId/hr-profile, which
//     answers 403 `forbidden_not_self` unless the caller is a platform
//     superuser (src/domains/users/services/UserHrProfileService.js:89 and
//     117-118 → src/core/services/PlatformSuperuser.js:65-72): the
//     `platformSuperuser` bit on the User record. That module's env
//     allowlist (break-glass service accounts) is invisible here.
//   • EXPORT — no rule beyond the page's own gate; never blocked here.
//
// `root.user` is the caller's own /auth/me record, and it carries both
// `globalRole` and `platformSuperuser`. No record yet is NOT a refusal: the
// server stays the guard (lane A1's shape — an unknown role is not read-only).
//
// ON A CUSTOMER (WHITE-LABEL) DOMAIN NOBODY MAY. Every request whose `Origin`
// is a verified white-label host runs inside a host lock
// (src/core/middleware/customDomainScope.js:250-277, mounted before the
// /workspace-project plane at src/index.js:619 and before core at :666).
// Inside it the purge's `isSuperadmin` is false (the bridge sends
// `hostLocked`, src/index.js:375-376 → workers/workspace-project/src/auth.js:
// 404-407) and so is `isPlatformSuperuser` (PlatformSuperuser.js:66) —
// platform admins and superusers included. The shell holds the same fact
// before it mounts: `root.whitelabelHostScope` (state.js), written by
// `seedWhitelabelHostScope` (functions/whitelabelBrand.js) from GET
// /core/organizations/custom-domain-scope, which answers the scope that very
// middleware locked the request to (OrganizationController.js:3849-3857).
// An object there is a bound customer domain; `false` is a customer domain
// whose tenant could not be established (an unbound verified row locks to
// nothing, customDomainScope.js:253, and the shell renders no tenant at all);
// `null` is a platform host. Both customer cases answer the domain sentence
// for both actions, before any role is read. Not mirrored: a handoff session
// token carried to a platform host (no flow sends one there) — the server's
// 403 stays the answer.
//
// THE one check of the page: `right` names the action's rule ('purge' |
// 'deactivate'); the answer is the sentence that says who can (or that this
// domain cannot) — the row shows it, and the button stays disabled and asks
// nothing — or null when this caller may run the action here. A registered
// function (`el.call`); `this` is the calling element.
export const adminDangerRoleBlock = function adminDangerRoleBlock(right) {
  const el = this
  if (right !== 'purge' && right !== 'deactivate') return null
  const root = (el && el.state && el.state.root) || null
  if (!root) return null
  const host = root.whitelabelHostScope
  if (host === false || (host && typeof host === 'object')) {
    return el.call('polyglot', 'admin.danger.domain.notAllowed')
  }
  const user = root.user
  if (!user || typeof user !== 'object') return null
  let key = null
  if (right === 'purge' && user.globalRole !== 'admin') {
    key = 'admin.danger.purgeChat.notAllowed'
  } else if (right === 'deactivate' && user.platformSuperuser !== true) {
    key = 'admin.danger.deactivate.notAllowed'
  }
  return key ? el.call('polyglot', key) : null
}
